/**
 * Created by Andrew on 7/10/2016.
 */

import React, { Component } from 'react';
import CustomerSSO from '../presentation/customer-sso';

export default class CustomerSSOWidget extends Component {

    state = { ssoDisplay: null };

    componentDidMount() {
        const accountId = this.props.id

        localStorage.setItem('accountId', accountId);
        this.loadSSODisplay();
    }

    loadSSODisplay = () => {
        const accountId = localStorage.getItem('accountId');
        const idToken = localStorage.getItem('idToken');
        const refreshToken = localStorage.getItem('refreshToken');

        console.log('process.env.POINT_ACCESS_URL: ', process.env.POINT_ACCESS_URL)

        let SSODisplay = <iframe className="iframe-styles" src={process.env.POINT_ACCESS_URL+"/zones?accountId="+accountId+"&idToken="+idToken+"&refreshToken="+refreshToken}></iframe>;
        this.setState({ssoDisplay: SSODisplay});
    };

    render() {
        return <CustomerSSO ssoDisplay={this.state.ssoDisplay} accountId={this.props.id} />
    }
}